import dayjs from 'dayjs';

/**
 * @description A custom hook that calculates a report start date.
 * The date is guaranteed to be at least 30 days prior to the current date and a Sunday.
 *
 * @returns {Object} An object containing the calculated Date object and a formatted date string.
 * @returns {Date} date - The calculated Date object.
 * @returns {string} formattedDate - The date formatted as 'YYYY-MM-DD'.
 */
export const getDefaultStartDate = () => {
  // Start with the current date
  const today = new Date();

  // Calculate a date that is at least 30 days in the past
  //const thirtyDaysAgo = new Date(today.setDate(today.getDate() - 30));
  const thirtyDaysAgo = new Date(today.setDate(today.getDate() - 90));

  // Find the most recent Sunday on or before that date
  // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const dayOfWeek = thirtyDaysAgo.getDay();
  const daysToSubtract = dayOfWeek === 0 ? 0 : dayOfWeek;
  const startDate = new Date(
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - daysToSubtract),
  );

  const formatted = dayjs(startDate).toISOString();

  return formatted;
};

export function calculateWorkdays(
  startDateString: string,
  endDateString: string,
  holidayStrings: string[],
): number {
  let workdayCount = 0;

  // Convert holiday strings to a Set for efficient lookup.
  // We normalize to a 'YYYY-MM-DD' format to ignore the time part.
  const holidaySet = new Set(
    holidayStrings.map((date) => date.substring(0, 10)),
  );

  // Create Date objects from the input strings
  const startDate = new Date(startDateString);
  const endDate = new Date(endDateString);

  // Initialize a loop variable with the start date.
  const currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;

    // Normalize the current date to a 'YYYY-MM-DD' format for holiday checking.
    const currentFormattedDate = currentDate.toISOString().substring(0, 10);
    const isHoliday = holidaySet.has(currentFormattedDate);

    if (isWeekday && !isHoliday) {
      workdayCount++;
    }

    // Move to the next day
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return workdayCount;
}
